var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 162,
  height: 48,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#loop_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#7D41FF",
  d: "M3 .506V22.52s.394 17.786 18.275 17.64h27.583M92.905 40.268c10.233 0 18.528-8.296 18.528-18.529S103.138 3.211 92.905 3.211s-18.528 8.295-18.528 18.528 8.295 18.529 18.528 18.529Z",
  style: {
    strokeWidth: 5.42295
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#7D41FF",
  d: "M50.425 5.923c-8.721 0-15.817 7.095-15.817 15.817 0 8.721 7.096 15.817 15.817 15.817S66.242 30.46 66.242 21.74 59.147 5.923 50.425 5.923m0-5.423c11.73 0 21.24 9.51 21.24 21.24s-9.51 21.24-21.24 21.24-21.24-9.51-21.24-21.24S38.696.5 50.426.5"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#7D41FF",
  d: "M140.76 40.268c10.233 0 18.529-8.296 18.529-18.529S150.993 3.211 140.76 3.211s-18.528 8.295-18.528 18.528 8.295 18.529 18.528 18.529Z",
  style: {
    strokeWidth: 5.42295
  }
}), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#7D41FF",
  d: "M124.943 20.836h-5.422v26.663h5.422zM63.651 30.43 73.83 12.388l2.596 8.779-9.297 13.467z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#7D41FF",
  d: "M79.94 30.848 68.558 10.656l-1.702 10.51 9.298 13.467zM104.948 32.032 124.15 8.496l-1.255 10.095-14.396 17.567z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "loop_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .5h162v47H0z"
})))));
export default SvgLoop;